import { ReactElement } from "react";

import { ICatalogueSetItem } from "../../../contexts/CartServiceContext/types";
import CartItemSetItem from "./CartItemSetItem";

interface IProps {
	setitems: ICatalogueSetItem[];
	parentQuantity: number;
}

const CartItemSet = ({ setitems, parentQuantity }: IProps): ReactElement => {
	return (
		<ul className="CartItemSet">
			{setitems.map((item) => (
				<CartItemSetItem item={item} parentQuantity={parentQuantity} key={item.external_id} />
			))}
		</ul>
	);
};

export default CartItemSet;
